import { action, extendObservable } from 'mobx'

import { projectApi } from '@atheneum/api'

import MetricModel from '@models/Project/Metric.model'

export default class MetricStore {
  constructor (projectId) {
    extendObservable(this, {
      loading: false,
      error: null,
      metric: null
    })

    if (projectId) {
      this.load(projectId)
    }
  }

  load = action(projectId => {
    this.loading = true
    return projectApi
      .getMetric(projectId)
      .then(metricData => {
        this.metric = new MetricModel(metricData)
        this.loading = false
      })
      .catch(error => {
        this.loading = false
        this.error = error
        this.growlStore.showError(error)
      })
  })
}
